module.exports = __webpack_public_path__ + "img/camp_shirt_other2.e7921b28.svg";